"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OurLetterModalBody = OurLetterModalBody;
const react_1 = __importStar(require("react"));
const BussinesObjectSelectors_1 = require("../../../View/Modals/CommonFormComponents/BussinesObjectSelectors");
const LetterModalBody_1 = require("./LetterModalBody");
const FormContext_1 = require("../../../View/Modals/FormContext");
const react_bootstrap_1 = require("react-bootstrap");
const LettersController_1 = require("../LettersController");
const InlineCreateDrawers_1 = require("../../../View/Modals/InlineCreateDrawers");
function OurLetterModalBody(props) {
    const { initialData, isEditing } = props;
    const { setValue, watch, register, } = (0, FormContext_1.useFormContext)();
    const _cases = watch("_cases");
    const [showCreateMain, setShowCreateMain] = (0, react_1.useState)(false);
    const [showCreateCc, setShowCreateCc] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        setValue("_entitiesMain", initialData?._entitiesMain, { shouldDirty: false, shouldValidate: true });
        setValue("_entitiesCc", initialData?._entitiesCc, { shouldDirty: false, shouldValidate: true });
    }, [initialData, setValue]);
    function handleMainCreated(created) {
        const current = watch("_entitiesMain") || [];
        setValue("_entitiesMain", [...current, created], { shouldValidate: true });
    }
    function handleCcCreated(created) {
        const current = watch("_entitiesCc") || [];
        setValue("_entitiesCc", [...current, created], { shouldValidate: true });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(LetterModalBody_1.LetterModalBody, { ...props }),
        !isEditing && react_1.default.createElement(BussinesObjectSelectors_1.OurLetterTemplateSelector, { _cases: _cases || [] }),
        react_1.default.createElement(react_bootstrap_1.Form.Group, null,
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Odbiorcy"),
            react_1.default.createElement(BussinesObjectSelectors_1.EntitySelector, { name: "_entitiesMain", multiple: true, onRequestCreate: () => setShowCreateMain(true) })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, null,
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Do wiadomo\u015Bci"),
            react_1.default.createElement(BussinesObjectSelectors_1.EntitySelector, { name: "_entitiesCc", multiple: true, onRequestCreate: () => setShowCreateCc(true) })),
        react_1.default.createElement("input", { type: "hidden", ...register("isOur"), value: "true" }),
        react_1.default.createElement(InlineCreateDrawers_1.EntityInlineCreateDrawer, { show: showCreateMain, onHide: () => setShowCreateMain(false), title: "Nowy podmiot (odbiorca)", repository: LettersController_1.entitiesRepository, onCreated: handleMainCreated }),
        react_1.default.createElement(InlineCreateDrawers_1.EntityInlineCreateDrawer, { show: showCreateCc, onHide: () => setShowCreateCc(false), title: "Nowy podmiot (do wiadomo\u015Bci)", repository: LettersController_1.entitiesRepository, onCreated: handleCcCreated })));
}
